import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{ref:"uploadInput",attrs:{"id":"upload-input","type":"file","name":"filename","hidden":"","multiple":""},on:{"change":_vm.performUpload}}),_c(VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c(VBtn,_vm._g(_vm._b({attrs:{"icon":"","small":""},on:{"click":_vm.uploadFiles}},'v-btn',attrs,false),on),[_c(VIcon,[_vm._v(" mdi-paperclip ")])],1)]}}])},[_vm._m(0)])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(_vm._s(_vm.$t('attachFiles')))])
}]

export { render, staticRenderFns }